import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-73e38986"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "status-box"
};
const _hoisted_2 = {
  key: 0,
  class: "status-progress"
};
const _hoisted_3 = {
  class: "word"
};
const _hoisted_4 = {
  key: 0,
  class: "item action-no-time"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "action-no-time-t"
}, "待设定", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "action-no-time-b"
}, "众筹上线时间", -1));
const _hoisted_7 = [_hoisted_5, _hoisted_6];
const _hoisted_8 = {
  key: 1,
  class: "item"
};
const _hoisted_9 = {
  class: "item countdown"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "天", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ":", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ":", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "即将开始", -1));
const _hoisted_14 = {
  class: "item money"
};
const _hoisted_15 = {
  class: "top"
};
const _hoisted_16 = {
  class: "info"
};
const _hoisted_17 = {
  class: "word"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-down",
  src: "https://p6.moimg.net/md/icon/project_bottom_more.png"
}, null, -1));
const _hoisted_19 = {
  class: "item time"
};
const _hoisted_20 = {
  key: 0,
  class: "top"
};
const _hoisted_21 = /*#__PURE__*/_createTextVNode("00:");
const _hoisted_22 = {
  key: 1,
  class: "top"
};
const _hoisted_23 = {
  class: "tips tips-words"
};
const _hoisted_24 = {
  class: "item target"
};
const _hoisted_25 = {
  class: "top"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "word"
}, "众筹目标"), /*#__PURE__*/_createElementVNode("img", {
  class: "icon-down",
  src: "https://p6.moimg.net/md/icon/project_bottom_more.png"
})], -1));
const _hoisted_27 = [_hoisted_26];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_progress = _resolveComponent("van-progress");
  const _component_CompSupportUser = _resolveComponent("CompSupportUser");
  const _component_CompGoals = _resolveComponent("CompGoals");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.product_info.status_code != 1 && $props.product_info.status_code != 13 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_van_progress, {
    class: "line",
    percentage: $props.product_info.progress > 100 ? 100 : $props.product_info.progress,
    "show-pivot": false,
    color: $options.process_color,
    "trank-color": "#EDEDED",
    "stroke-width": "4"
  }, null, 8, ["percentage", "color"]), _createElementVNode("div", _hoisted_3, _toDisplayString($props.product_info.progress) + "%", 1)])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(['status-info', {
      'status-info-line': $props.product_info.status_code == 1
    }])
  }, [$props.product_info.status_code == 13 ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7)) : $props.product_info.status_code == 1 && $props.product_info.time_remaining ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", null, [$options.remaining.length == 4 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("i", null, _toDisplayString($options.remaining[3]), 1), _hoisted_10], 64)) : _createCommentVNode("", true), _createElementVNode("i", null, _toDisplayString($options.remaining.length >= 3 ? $options.remaining[2] : '00'), 1), _hoisted_11, _createElementVNode("i", null, _toDisplayString($options.remaining.length >= 2 ? $options.remaining[1] : '00'), 1), _hoisted_12, _createElementVNode("i", null, _toDisplayString($options.remaining[0]), 1)]), _hoisted_13])])) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, "￥" + _toDisplayString($options.fNum($props.product_info.backer_money)), 1), _createElementVNode("div", {
    class: "tips tips-down",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onSupportUser && $options.onSupportUser(...args))
  }, [_createElementVNode("div", _hoisted_16, [_createElementVNode("span", _hoisted_17, _toDisplayString($props.product_info.backer_count) + "人支持", 1), _hoisted_18])])]), _createElementVNode("div", _hoisted_19, [$props.product_info.status_code == 0 && $props.product_info.count_down_time ? (_openBlock(), _createElementBlock("span", _hoisted_20, [$options.time_count_down.length == 4 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createTextVNode(_toDisplayString($options.time_count_down[3]) + "天", 1)], 64)) : _createCommentVNode("", true), $options.time_count_down.length >= 3 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createTextVNode(_toDisplayString($options.time_count_down[2]) + ":", 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_hoisted_21], 64)), $options.time_count_down.length >= 2 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 3
  }, [_createTextVNode(_toDisplayString($options.time_count_down[1]) + ":", 1)], 64)) : _createCommentVNode("", true), _createTextVNode(_toDisplayString($options.time_count_down[0]), 1)])) : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString($props.product_info.left_time), 1)), _createElementVNode("div", _hoisted_23, _toDisplayString($props.product_info.status_code == 0 || $props.product_info.is_preview ? "剩余时间" : "结束时间"), 1)])], 64)), _createElementVNode("div", _hoisted_24, [_createElementVNode("span", _hoisted_25, "¥" + _toDisplayString($options.fNum($props.product_info.install_money, 0)), 1), _createElementVNode("div", {
    class: "tips tips-down",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.onTarget && $options.onTarget(...args))
  }, _hoisted_27)])], 2), _createVNode(_component_CompSupportUser, {
    show: $data.showSupportUser,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $data.showSupportUser = $event),
    pro_id: $props.product_info.id
  }, null, 8, ["show", "pro_id"]), _createVNode(_component_CompGoals, {
    show: $data.showTarget,
    "onUpdate:show": _cache[3] || (_cache[3] = $event => $data.showTarget = $event),
    pro_id: $props.product_info.id,
    status_desc: $props.product_info.status_desc && $data.status_code_arr.includes($props.product_info.status_code),
    status_code: $props.product_info.status_code
  }, null, 8, ["show", "pro_id", "status_desc", "status_code"])]);
}